import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface Calendar {
  id: string;
  alias: string;
  title: string;
  calendarType: string;
  city: string;
  createdAt: Date;
  updatedAt: Date;
  durationEvent: number;
  intervalEvent: number;
  intervalProfessionalSetup: number;
  inviteFisicalAddress: string;
  inviteType: string;
  minimumTimeToSchedule: number;
}

export interface CalendarAvailables {
  calendarsAvailables: Calendar[];
  calendarSelected: Calendar | null;
  doctorId?: string | null;
}

export enum ECalendarType {
  'MAIN' = 'MAIN',
  'RETURN' = 'RETURN',
  'BOTH' = 'BOTH'
}
export interface ICalaendarType {
  calendarId: string;
  createdAt: string;
  id: string;
  productId: string;
  type: ECalendarType;
  updatedAt: string;
}

export const calendarSlice = createSlice({
  name: 'calendars',
  initialState: {
    calendarsAvailables: [] as Calendar[],
    calendarSelected: null
  } as CalendarAvailables,
  reducers: {
    saveAvailableCalendars: (state, action: PayloadAction<Calendar[]>) => {
      state.calendarsAvailables = action.payload;
    },
    saveCalendarSelected: (state, action: PayloadAction<{ calendar: Calendar; doctorId?: string } | null>) => {
      const { calendar, doctorId } = action.payload || { calendar: null, doctorId: null };
      state.calendarSelected = calendar;
      state.doctorId = doctorId;
    },
    clearCalendarSelected: state => {
      state.calendarSelected = null;
    }
  }
});

export const { saveAvailableCalendars, saveCalendarSelected, clearCalendarSelected } = calendarSlice.actions;
export const calendarReducer = calendarSlice.reducer;
